import { createSlice } from "@reduxjs/toolkit";

const integrationsSlice = createSlice({
  name: "integrations",
  initialState: {
    loading: false,
    deployInt: "",
    getConfig: "",
    deleteConfig: "",
    updateConfig: "",
    deleteInt: "",
    setConfig: "",
    resetConfigLoading: false,
    togglePhishboxLlmLoading: false,
    error: "",
    checkConfig: false,
    action: false,
    loadingUpdate: false,
    agentStatus: [],
    agentInstallationList: [],
    threatHunterList: [],
    newAgentUrl: "",
    analyzeAgentLoading: false,
    analyzeAgentError: null,
    yaraScanAgentLoading: false,
    yaraScanAgentError: null,
    agentAnalysisData: {},
    agentAnalysisDataLoading: false,
    agentAnalysisDataError: null,
    generateAgentAiDecisionLoading: false,
    generatedAgentAiDecision: "",
    generatedAgentAiDecisionLoading: false,
    agentSigmaOutput: [],
    agentSigmaOutputLoading: false,
    agentProcessSnapshot: null,
    agentProcessSnapshotLoading: false,
    agentIocResults: [],
    agentIocResultsLoading: false,
    agentGroups: [],
    agentGroupsLoading: false,
    allAgentGroups: [],
    allAgentGroupsLoading: false,
    bulkAgentCommandLoading: false,
    createAgentGroupLoading: false,
    successCreateAgentGroup: false,
    agentPolicies: [],
    agentPoliciesLoading: false,
    agentPolicy: {},
    agentPolicyLoading: false,
    updatePolicyLoading: false,
    resetPolicyLoading: false,
    repairPolicyLoading: false,
    deletePolicyLoading: false,
    deletedPolicy: false,
    distinctLiveThreatHunters: [],
    tapInterfaces: [],
    tapInterfacesLoading: false,
    hunterBoxList: [],
    hunterBoxListLoading: false,
    hunterBoxListPageCount: 0,
    hunterBoxActiveTab: "Latest",
    hunterBoxTabSwitching: false,
    yaraResultsList: [],
    yaraResultsListLoading: false,
    yaraResultsListPageCount: 0,
    yaraResultsActiveTab: "Group by Rule",
    yaraResultsTabSwitching: false,
    hunterBoxStatistics: {
      cleanCount: 0,
      suspiciousCount: 0,
      maliciousCount: 0,
      agentCount: 0,
      uiCount: 0,
      publicApiCount: 0,
      totalCount: 0,
    },
    threatHunterSubmitLoading: false,
    agentSandboxSubmitLoading: false,
    // Keyed by sha256: several detections can be on screen at once.
    detectionSandboxTasks: {},
    agentSandboxTasks: [],
    agentSandboxTasksTotal: 0,
    agentSandboxTasksLoading: false,
    agentSandboxTasksAgentOnline: false,
    cancelAgentSandboxTaskLoading: false,
    threatHunterDashboard: null,
    threatHunterDashboardLoading: false,
  },
  reducers: {
    RequestDeployInt: (state) => {
      state.loading = true;
      state.action = true;
    },
    SuccessDeployInt: (state, payload) => {
      state.loading = false;
      state.deployInt = payload.payload;
      state.action = false;
    },
    FailureDeployInt: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
      state.action = false;
    },
    RequestGetConfig: (state) => {
      state.loading = true;
    },
    SuccessGetConfig: (state, payload) => {
      state.loading = false;
      state.getConfig = payload.payload;
    },
    FailureGetConfig: (state, payload) => {
      state.getConfig = "";
      state.loading = false;
      state.error = payload.payload;
    },
    RequestDeleteInt: (state) => {
      state.loading = true;
      state.action = true;
    },
    SuccessDeleteInt: (state, payload) => {
      state.loading = false;
      state.deleteInt = payload.payload;
      state.action = false;
    },
    FailureDeleteInt: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
      state.action = false;
    },
    RequestSetConfig: (state) => {
      state.loading = true;
    },
    SuccessSetConfig: (state, payload) => {
      state.loading = false;
      state.setConfig = payload.payload;
    },
    FailureSetConfig: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    RequestResetConfig: (state) => {
      state.resetConfigLoading = true;
    },
    SuccessResetConfig: (state) => {
      state.resetConfigLoading = false;
    },
    FailureResetConfig: (state, payload) => {
      state.resetConfigLoading = false;
      state.error = payload.payload;
    },
    RequestTogglePhishboxLlm: (state) => {
      state.togglePhishboxLlmLoading = true;
    },
    SuccessTogglePhishboxLlm: (state) => {
      state.togglePhishboxLlmLoading = false;
    },
    FailureTogglePhishboxLlm: (state) => {
      state.togglePhishboxLlmLoading = false;
    },
    RequestCheckConfig: (state) => {
      state.loading = true;
    },
    SuccessCheckConfig: (state, payload) => {
      state.loading = false;
      state.checkConfig = payload.payload;
    },
    FailureCheckConfig: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    ClearGetConfig: (state) => {
      state.getConfig = "";
      state.deleteConfig = "";
      state.updateConfig = "";
      state.setConfig = "";
    },
    RequestDeleteConfig: (state) => {
      state.loading = true;
    },
    SuccessDeleteConfig: (state, payload) => {
      state.loading = false;
      state.deleteConfig = payload.payload;
    },
    FailureDeleteConfig: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    RequestUpdateConfig: (state) => {
      state.loadingUpdate = true;
    },
    SuccessUpdateConfig: (state, payload) => {
      state.loadingUpdate = false;
      state.updateConfig = payload.payload;
    },
    FailureUpdateConfig: (state, payload) => {
      state.loadingUpdate = false;
      state.error = payload.payload;
    },
    RequestAgentStatus: (state) => {
      state.loading = true;
    },
    SuccessAgentStatus: (state, payload) => {
      state.loading = false;
      state.agentStatus = payload.payload;
    },
    FailureAgentStatus: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    RequestAgentInstallationList: (state) => {
      state.loading = true;
    },
    SuccessAgentInstallationList: (state, payload) => {
      state.loading = false;
      state.agentInstallationList = payload.payload;
    },
    FailureAgentInstallationList: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    // RequestAllAgentsThreatHunter: (state) => {
    //   state.loading = true;
    // },
    // SuccessAllAgentsThreatHunter: (state, payload) => {
    //   state.loading = false;
    //   state.threatHunterList = payload.payload;
    // },
    // FaliureAllAgentsThreatHunter: (state, payload) => {
    //   state.loading = false;
    //   state.error = payload.payload;
    // },
    RequestSingleAgentDataThunter: (state) => {
      state.loading = true;
    },
    SuccessSingleAgentDataThunter: (state, payload) => {
      state.loading = false;
      state.threatHunterList = payload.payload;
    },
    FaliureSingleAgentDataThunter: (state, payload) => {
      state.threatHunterList = [];
      state.loading = false;
      state.error = payload.payload;
    },
    RequestSingleAgentIocResults: (state) => {
      state.agentIocResultsLoading = true;
    },
    SuccessSingleAgentIocResults: (state, action) => {
      state.agentIocResults = action.payload;
      state.agentIocResultsLoading = false;
    },
    FailureSingleAgentIocResults: (state) => {
      state.agentIocResults = [];
      state.agentIocResultsLoading = false;
    },
    RequestCreateNewAgent: (state) => {
      state.loading = true;
      state.error = null;
    },
    SuccessCreateNewAgent: (state, payload) => {
      state.loading = false;
      state.newAgentUrl = payload.payload;
      state.error = null;
    },
    FailureCreateNewAgent: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    ResetCreateNewAgent: (state) => {
      state.loading = false;
      state.error = null;
      state.newAgentUrl = "";
    },
    RequestAnalyzeAgent: (state) => {
      state.analyzeAgentLoading = true;
      state.analyzeAgentError = null;
    },
    SuccessAnalyzeAgent: (state, payload) => {
      state.analyzeAgentLoading = false;
      state.analyzeAgentError = null;
    },
    FailureAnalyzeAgent: (state, payload) => {
      state.analyzeAgentLoading = false;
      state.analyzeAgentError = payload.payload;
    },
    RequestYaraScanAgent: (state) => {
      state.yaraScanAgentLoading = true;
      state.yaraScanAgentError = null;
    },
    SuccessYaraScanAgent: (state) => {
      state.yaraScanAgentLoading = false;
      state.yaraScanAgentError = null;
    },
    FailureYaraScanAgent: (state, action) => {
      state.yaraScanAgentLoading = false;
      state.yaraScanAgentError = action.payload;
    },
    RequestAgentAnalysisData: (state) => {
      state.agentAnalysisDataLoading = true;
      state.agentAnalysisDataError = null;
    },
    SuccessAgentAnalysisData: (state, payload) => {
      state.agentAnalysisDataLoading = false;
      state.agentAnalysisData = payload.payload;
      state.agentAnalysisDataError = null;
    },
    FailureAgentAnalysisData: (state, payload) => {
      state.agentAnalysisDataLoading = false;
      state.agentAnalysisDataError = payload.payload;
    },
    RequestAgentSigmaOutput: (state) => {
      state.agentSigmaOutputLoading = true;
    },
    SuccessAgentSigmaOutput: (state, action) => {
      state.agentSigmaOutput = action.payload;
      state.agentSigmaOutputLoading = false;
    },
    FailureAgentSigmaOutput: (state) => {
      state.agentSigmaOutput = [];
      state.agentSigmaOutputLoading = false;
    },
    RequestAgentProcessSnapshot: (state) => {
      state.agentProcessSnapshot = null;
      state.agentProcessSnapshotLoading = true;
    },
    SuccessAgentProcessSnapshot: (state, action) => {
      state.agentProcessSnapshot = action.payload;
      state.agentProcessSnapshotLoading = false;
    },
    FailureAgentProcessSnapshot: (state) => {
      state.agentProcessSnapshot = null;
      state.agentProcessSnapshotLoading = false;
    },
    RequestUpdateAgentDescription: (state) => {
      state.loading = true;
      state.error = null;
    },
    SuccessUpdateAgentDescription: (state, payload) => {
      state.loading = false;
      state.newAgentUrl = payload.payload;
      state.error = null;
    },
    FailureUpdateAgentDescription: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    RequestDeleteAgentRecord: (state) => {},
    SuccessDeleteAgentRecord: (state) => {},
    FailureDeleteAgentRecord: (state) => {},
    RequestDistinctLiveThreatHunters: (state) => {},
    SuccessDistinctLiveThreatHunters: (state, action) => {
      state.distinctLiveThreatHunters = action.payload;
    },
    FailureDistinctLiveThreatHunters: (state) => {
      state.distinctLiveThreatHunters = [];
    },
    RequestAgentGroups: (state) => {
      state.agentGroupsLoading = true;
    },
    SuccessAgentGroups: (state, action) => {
      state.agentGroups = action.payload;
      state.agentGroupsLoading = false;
    },
    FailureAgentGroups: (state) => {
      state.agentGroupsLoading = false;
    },
    RequestAllAgentGroups: (state) => {
      state.allAgentGroupsLoading = true;
    },
    SuccessAllAgentGroups: (state, action) => {
      state.allAgentGroups = action.payload;
      state.allAgentGroupsLoading = false;
    },
    FailureAllAgentGroups: (state) => {
      state.allAgentGroups = [];
      state.allAgentGroupsLoading = false;
    },
    RequestBulkAnalyzeAgents: (state) => {
      state.bulkAgentCommandLoading = true;
    },
    SuccessBulkAnalyzeAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    FailureBulkAnalyzeAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    RequestBulkYaraScanAgents: (state) => {
      state.bulkAgentCommandLoading = true;
    },
    SuccessBulkYaraScanAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    FailureBulkYaraScanAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    RequestBulkDeleteAgents: (state) => {
      state.bulkAgentCommandLoading = true;
    },
    SuccessBulkDeleteAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    FailureBulkDeleteAgents: (state) => {
      state.bulkAgentCommandLoading = false;
    },
    RequestCreateAgentGroup: (state) => {
      state.createAgentGroupLoading = true;
      state.successCreateAgentGroup = false;
    },
    SuccessCreateAgentGroup: (state) => {
      state.createAgentGroupLoading = false;
      state.successCreateAgentGroup = true;
    },
    FailureCreateAgentGroup: (state) => {
      state.createAgentGroupLoading = false;
      state.successCreateAgentGroup = false;
    },
    RequestDeleteAgentGroup: (state) => {},
    SuccessDeleteAgentGroup: (state) => {},
    FailureDeleteAgentGroup: (state) => {},
    RequestAgentPolicies: (state) => {
      state.agentPoliciesLoading = true;
    },
    SuccessAgentPolicies: (state, action) => {
      state.agentPolicies = action.payload;
      state.agentPoliciesLoading = false;
    },
    FailureAgentPolicies: (state) => {
      state.agentPolicies = [];
      state.agentPoliciesLoading = false;
    },
    RequestCreateAgentPolicy: () => {},
    SuccessCreateAgentPolicy: () => {},
    FailureCreateAgentPolicy: () => {},
    RequestAgentPolicy: (state) => {
      state.agentPolicyLoading = true;
    },
    SuccessAgentPolicy: (state, action) => {
      state.agentPolicy = action.payload;
      state.agentPolicyLoading = false;
    },
    FailureAgentPolicy: (state) => {
      state.agentPolicy = {};
      state.agentPolicyLoading = false;
    },
    RequestMoveAgentPolicy: (state) => {},
    SuccessMoveAgentPolicy: (state) => {},
    FailureMoveAgentPolicy: (state) => {},
    RequestUpdateAgentPolicy: (state) => {
      state.updatePolicyLoading = true;
    },
    SuccessUpdateAgentPolicy: (state) => {
      state.updatePolicyLoading = false;
    },
    FailureUpdateAgentPolicy: (state) => {
      state.updatePolicyLoading = false;
    },
    RequestDeleteAgentPolicy: (state) => {},
    SuccessDeleteAgentPolicy: (state) => {},
    FailureDeleteAgentPolicy: (state) => {},
    RequestResetAgentPolicy: (state) => {
      state.resetPolicyLoading = true;
    },
    SuccessResetAgentPolicy: (state) => {
      state.resetPolicyLoading = false;
    },
    FailureResetAgentPolicy: (state) => {
      state.resetPolicyLoading = false;
    },
    RequestRepairAgentPolicy: (state) => {
      state.repairPolicyLoading = true;
    },
    SuccessRepairAgentPolicy: (state) => {
      state.repairPolicyLoading = false;
    },
    FailureRepairAgentPolicy: (state) => {
      state.repairPolicyLoading = false;
    },
    RequestTapInterfaces: (state) => {
      state.tapInterfacesLoading = true;
    },
    SuccessTapInterfaces: (state, action) => {
      state.tapInterfaces = action.payload;
      state.tapInterfacesLoading = false;
    },
    FailureTapInterfaces: (state) => {
      state.tapInterfaces = [];
      state.tapInterfacesLoading = false;
    },
    SetHunterBoxActiveTab: (state, action) => {
      state.hunterBoxActiveTab = action.payload;
      state.hunterBoxTabSwitching = true;
    },
    RequestHunterBoxList: (state) => {
      state.hunterBoxListLoading = true;
    },
    SuccessHunterBoxList: (state, action) => {
      const { list, page_count } = action.payload;
      state.hunterBoxListLoading = false;
      state.hunterBoxList = list;
      state.hunterBoxListPageCount = page_count;
      state.hunterBoxTabSwitching = false;
    },
    FailureHunterBoxList: (state) => {
      state.hunterBoxListLoading = false;
      state.hunterBoxList = [];
      state.hunterBoxListPageCount = 0;
      state.hunterBoxTabSwitching = false;
    },
    SetYaraResultsActiveTab: (state, action) => {
      state.yaraResultsActiveTab = action.payload;
      state.yaraResultsTabSwitching = true;
    },
    RequestYaraResultsList: (state) => {
      state.yaraResultsListLoading = true;
    },
    SuccessYaraResultsList: (state, action) => {
      const { list, page_count } = action.payload;
      state.yaraResultsListLoading = false;
      state.yaraResultsList = list;
      state.yaraResultsListPageCount = page_count;
      state.yaraResultsTabSwitching = false;
    },
    FailureYaraResultsList: (state) => {
      state.yaraResultsListLoading = false;
      state.yaraResultsList = [];
      state.yaraResultsListPageCount = 0;
      state.yaraResultsTabSwitching = false;
    },
    RequestHunterBoxStats: (state) => {},
    SuccessHunterBoxStats: (state, action) => {
      const {
        clean_count,
        suspicious_count,
        malicious_count,
        agent_count,
        ui_count,
        public_api_count,
        total_count,
      } = action.payload;
      state.hunterBoxStatistics.cleanCount = clean_count;
      state.hunterBoxStatistics.suspiciousCount = suspicious_count;
      state.hunterBoxStatistics.maliciousCount = malicious_count;
      state.hunterBoxStatistics.agentCount = agent_count;
      state.hunterBoxStatistics.uiCount = ui_count;
      state.hunterBoxStatistics.publicApiCount = public_api_count ?? 0;
      state.hunterBoxStatistics.totalCount = total_count;
    },
    FailureHunterBoxStats: (state) => {
      state.hunterBoxStatistics.cleanCount = 0;
      state.hunterBoxStatistics.suspiciousCount = 0;
      state.hunterBoxStatistics.maliciousCount = 0;
      state.hunterBoxStatistics.agentCount = 0;
      state.hunterBoxStatistics.uiCount = 0;
      state.hunterBoxStatistics.publicApiCount = 0;
      state.hunterBoxStatistics.totalCount = 0;
    },
    RequestThreatHunterSubmit: (state) => {
      state.threatHunterSubmitLoading = true;
    },
    SuccessThreatHunterSubmit: (state) => {
      state.threatHunterSubmitLoading = false;
    },
    FailureThreatHunterSubmit: (state) => {
      state.threatHunterSubmitLoading = false;
    },
    RequestGenerateAgentAIDecision: (state) => {
      state.generateAgentAiDecisionLoading = true;
    },
    SuccessGenerateAgentAIDecision: (state) => {
      state.generateAgentAiDecisionLoading = false;
    },
    FailureGenerateAgentAIDecision: (state) => {
      state.generateAgentAiDecisionLoading = false;
    },
    RequestGetAgentAIDecision: (state) => {
      state.generatedAgentAiDecisionLoading = true;
    },
    SuccessGetAgentAIDecision: (state, action) => {
      state.generatedAgentAiDecision = action.payload;
      state.generatedAgentAiDecisionLoading = false;
    },
    FailureGetAgentAIDecision: (state) => {
      state.generatedAgentAiDecision = "";
      state.generatedAgentAiDecisionLoading = false;
    },
    RequestAgentSandboxSubmit: (state) => {
      state.agentSandboxSubmitLoading = true;
    },
    SuccessAgentSandboxSubmit: (state) => {
      state.agentSandboxSubmitLoading = false;
    },
    FailureAgentSandboxSubmit: (state) => {
      state.agentSandboxSubmitLoading = false;
    },
    RequestDetectionSandboxTasks: () => {},
    SuccessDetectionSandboxTasks: (state, action) => {
      state.detectionSandboxTasks[action.payload.sha256] = action.payload.tasks || [];
    },
    FailureDetectionSandboxTasks: (state, action) => {
      state.detectionSandboxTasks[action.payload.sha256] = [];
    },
    RequestAgentSandboxTasks: (state, action) => {
      // Background refreshes keep the table on screen instead of flashing a loader.
      if (!action.payload?.silent) state.agentSandboxTasksLoading = true;
    },
    SuccessAgentSandboxTasks: (state, action) => {
      state.agentSandboxTasksLoading = false;
      state.agentSandboxTasks = action.payload?.tasks || [];
      state.agentSandboxTasksTotal = action.payload?.total || 0;
      state.agentSandboxTasksAgentOnline = !!action.payload?.agentOnline;
    },
    FailureAgentSandboxTasks: (state) => {
      state.agentSandboxTasksLoading = false;
      state.agentSandboxTasks = [];
      state.agentSandboxTasksTotal = 0;
    },
    RequestCancelAgentSandboxTask: (state) => {
      state.cancelAgentSandboxTaskLoading = true;
    },
    SuccessCancelAgentSandboxTask: (state) => {
      state.cancelAgentSandboxTaskLoading = false;
    },
    FailureCancelAgentSandboxTask: (state) => {
      state.cancelAgentSandboxTaskLoading = false;
    },
    RequestThreatHunterDashboard: (state) => {
      state.threatHunterDashboardLoading = true;
    },
    SuccessThreatHunterDashboard: (state, action) => {
      state.threatHunterDashboardLoading = false;
      state.threatHunterDashboard = action.payload;
    },
    FailureThreatHunterDashboard: (state) => {
      state.threatHunterDashboardLoading = false;
      state.threatHunterDashboard = null;
    },
  },
});

export default integrationsSlice;
